<template>
<div class="to-self">
  <el-row>
    <el-col
      :lg="8"
      :sm="8"
      :xs="24"
    >
      <el-form
        class="elform"
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <el-form-item
          :label="$t('Accounts_receivable')"
          prop="toAccount"
        >
          <el-input
            :placeholder="$t('please_input')"
            v-model="form.toAccount"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Payees_email')"
        >
          <el-input
            :placeholder="$t('please_input')"
            v-model="form.toEmail"
          >
          </el-input>
          <p class="email-desc">{{$t('User.transDesc')}}</p>
        </el-form-item>
        <el-form-item
        >
          <div class="nav-title">{{$t('Amount_that_can_be_withdrawn')}}</div>
          <p class="balance">${{fromAccountInfo.availableBalance || 0}}</p>
        </el-form-item>
        <el-form-item
          :label="$t('User.transAmount')"
          prop="amount"
          class="has-prefix-item"
        >
          <el-input
            :placeholder="$t('please_input')"
            :value="form.amount"
            @input="inputHandle"
          >
            <span slot="prefix">$</span>
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Verification_mode')"
          prop="veriType"
          class="has-prefix-item"
        >
          <el-select
            style="width: 100%"
            v-model="form.veriType"
          >
            <el-option
              v-for="(item,index) in veriTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <p>{{phoneOrEmail}}</p>
        </el-form-item>
        <el-form-item
          :label="$t('Verification_Code')"
          prop="veriCode"
        >
          <div class="code-box pr">
            <el-input
              :placeholder="$t('please_input')"
              v-model="form.veriCode"
              class="w-full"
            ></el-input>
            <span class="code-btn-text active pa theme-color pointer" v-if="isCode"
                  @click="getCode">{{$t('Send_verification_code')}}</span>
            <span class="code-btn-text pa theme-color" v-else>{{isCodeNumber}}s {{$t('Register.againVer')}}</span>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            class="sure-btn"
            type="primary"
            :loading="submitLoading"
            @click="payHandle"
          >{{$t('Confirm_transfer_out')}}</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</div>
</template>

<script>
import { getTransferPhoneVer,mt4Transfer } from '@/api/userCenter.js';
import { mapGetters } from 'vuex'
import {amountInputValidate, onlyTwoBitFloat, validatEmail} from "@/utils/validate";
export default {
  name: "toOther",
  props: {
    currentAccount: {
      type: Number,
    },
    accountList:{
      type: Array,
      default(){
        return [];
      }
    }
  },
  data() {
    let _this = this;
    var validateEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('please_input_your_email')));
      } else {
        if (!validatEmail(value)) {
          callback(new Error(_this.$t('Register.errorMail')));
        } else {
          callback();
        }
      }
    };
    var validateMoney = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('payChannel.inputMoney')));
      }else {
        if(!onlyTwoBitFloat(value)){
          callback(new Error(this.$t('User.onlyInputTwoBitNumber')));
          this.$emit('request-err');
          return;
        }else {
          callback();
        }
      }
    };
    return {
      // 表单
      veriTypeList:[
        { label: _this.$t('mobile_phone'), value: 1 },
        { label: _this.$t('email'), value: 2 },
      ],
      form: {
        toAccount: '',
        toEmail: '',
        amount: '',
        veriType: 1,
        veriCode: '',
      },
      rules: {
        toAccount: [
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
        ],
        toEmail: [
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' },
        ],
        amount: [
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
          { validator: validateMoney, trigger: 'blur' },
        ],
        veriCode: [
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
        ],
      },
      // 发送验证码
      isCode: true,
      isCodeNumber: 60,
      submitLoading: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    phoneOrEmail(){
      if(this.form.veriType == 1){
        return this.userInfo.phone;
      }else {
        return this.userInfo.email;
      }
    },
    fromAccountInfo(){
      if(!this.accountList.length){
        return {
          availableBalance: '',
        }
      }else {
        let currentMtInfo = this.accountList.filter((item) => {
          return item.login == this.currentAccount;
        });
        return currentMtInfo[0];
      }
    },
  },
  methods: {
    inputHandle(val){
      this.form.amount = amountInputValidate(val);
    },
    payHandle(item){
      this.$refs.form.validate((valid) => {
        if(valid){
          this.applyRequest();
        }else {
          console.log('no-pass');
        }
      })
    },
    applyRequest(){
      let parmas = {
        oprCustId : this.userInfo.id,
        transferType : 2,
        oprLogin : this.fromAccountInfo.login,
        targetLogin : this.form.toAccount,
        amount : this.form.amount,
        targetEmail : this.form.toEmail,
        phoneVerCode : this.form.veriCode,
        type: this.form.veriType,
      }
      this.submitLoading = true;
      mt4Transfer(parmas).then((res) => {

        this.$emit('reduce-balance',this.form.amount);
        this.submitLoading = false;

        this.$message({
          type: 'success',
          message: this.$t('Submitted_please_wait_for_review')
        });

      }).catch((res) => {
        this.submitLoading = false;
      })
    },
    getCode() {
      let parmas = {
        custId: this.userInfo.id,
        type: this.form.veriType,
      }
      getTransferPhoneVer(parmas).then((res) => {
        if(res){
          this.isCode = false;
          this.timerOut();

          this.$message({
            message: this.$t('User.verCodeSendSuccess'),
            type: 'success'
          });
        }
      })
    },
    timerOut() {
      let _this = this;
      let timer1 = setTimeout(() => {
        clearTimeout(timer1);
        if (_this.isCodeNumber > 0) {
          _this.isCodeNumber = --_this.isCodeNumber;
          _this.timerOut();
        } else {
          clearTimeout(timer1);
          this.isCode = true;
          this.isCodeNumber = 60;
        }
      }, 1000);
    },
  },
}
</script>

<style lang="scss" scoped>
.to-self {
  padding-top: 20px;
  .nav-title {
    font-size: 16px;
    font-weight: 600;
    color: #5E5873;
  }
  .email-desc {
    line-height: 1.5;
    margin-top: 10px;
    color: #B9B9C3;
  }
  .balance {
    font-size: 16px;
    font-weight: 600;
    color: #D85E5F;
    line-height: 1.2;
  }
  .code-btn-text {
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
  .has-prefix-item {
    /deep/ .el-input__prefix {
      left: 15px;
    }
  }
  .sure-btn {
    margin-top: 30px;
  }
}
</style>
